<template>
  <v-dialog v-model="cameraTourDialogVisible" width="700">
    <customDialog>
      <template v-slot:title>
        {{'ツアー'}}
        <button id="dialog_exit">
          <img src="@/assets/images/popup_close.png" id="btn_img" @click="cameraTourDialogVisible = false">
        </button>
      </template>
      <template v-slot:body>
        <v-row class="ma-0 pa-0" justify="center">
          <v-col class="ma-0 pa-0" cols="10">
            <v-row class="ma-0 pa-0" justify="center">
              <v-col class="ma-0 pa-0" id="tour_dialog_text">
                <v-row class="ma-0 pa-0">
                  <v-col class="ma-0 pa-0 pl-2" cols="3">
                    {{'時間設定'}}
                  </v-col>
                  <v-col class="ma-0 pa-0 pl-2" cols="4">
                    {{'店舗'}}
                  </v-col>
                  <v-col class="ma-0 pa-0 pl-2" cols="5">
                    {{'カメラ設定'}}
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0 pt-2 pb-2" id="dialog_row"
                   v-for="(item, index) in tourList" :key="index">
                  <v-col class="ma-0 pa-0 pr-2" cols="3">
                    <v-select class="ml-2" background-color="#272727" dark
                      :items="item.timeList" dense hide-details outlined 
                      item-text="label" item-value="value">
                    </v-select>
                  </v-col>
                  <v-col class="ma-0 pa-0" cols="4">
                    <v-select class="ml-2 pr-2" background-color="#272727" dark
                      :items="item.storeList" dense hide-details outlined 
                      item-text="label" item-value="value">
                    </v-select>
                  </v-col>
                  <v-col class="ma-0 pa-0" cols="4">
                    <v-select class="ml-2 pr-2" background-color="#272727" dark
                      :items="item.cameraSettingList" dense hide-details outlined 
                      item-text="label" item-value="value">
                    </v-select>
                  </v-col>
                  <v-col class="ma-0 pa-0" cols="1" >
                    <v-btn id="transparent_btn_small" elevation="0" :ripple="false" @click="deleteTourItem(index)">
                      <v-img src="@/assets/images/close.png"></v-img>
                    </v-btn>
                  </v-col>
                </v-row>
                <v-row class="ma-0 pa-0 mt-2 mb-10">
                  <v-btn id="blue_btn" @click="cameraTourDialog = false">
                    {{'追加'}}
                  </v-btn>
                </v-row>
              </v-col>
            </v-row>
            <v-row class="ma-0 pa-0 pb-2" align="center" justify="center">
              <v-btn class="ma-0 pa-0 ml-2" id="grey_btn" @click="cameraTourDialogVisible = false"
                width="8rem" height="2rem">{{'キャンセル'}}</v-btn>
              <v-btn class="ma-0 pa-0 ml-2" id="blue_btn" @click="cameraTourDialogVisible = false"
                width="8rem" height="2rem">{{'確定'}}</v-btn>
            </v-row>
          </v-col>
        </v-row>
      </template>
    </customDialog>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin';
import customDialog from '@/components/Modal.vue';
export default {
  props: {
    dialogVisible: Boolean,
    storeDataVisible: Boolean,
  },
  components: {
    customDialog,
  },
  mixins: [mixin.common],
  data: () => ({
    cameraTourDialogVisible: false,
    tourList: [
      {
        timeList: [
          { label: '5秒', value: '5秒'},
          { label: '10秒', value: '10秒'},
          { label: '15秒', value: '15秒'},
          { label: '20秒', value: '20秒'},
          { label: '30秒', value: '30秒'},
          { label: '60秒', value: '60秒'},
        ],
        storeList: [
          { label: '吉祥寺北口店', value: '吉祥寺北口店'},
          { label: '荻窪店', value: '荻窪店'},
          { label: '高円寺店', value: '高円寺店'},
          { label: '中野店', value: '中野店'},
        ],
        cameraSettingList: [
          { label: '厨房前', value: '厨房前'},
        ]
      },
      {
        timeList: [
          { label: '5秒', value: '5秒'},
        ],
        storeList: [
          { label: '荻窪店', value: '荻窪店'},
        ],
        cameraSettingList: [
          { label: '厨房前', value: '厨房前'},
        ]
      },
      {
        timeList: [
          { label: '5秒', value: '5秒'},
        ],
        storeList: [
          { label: '高円寺店', value: '高円寺店'},
        ],
        cameraSettingList: [
          { label: '厨房前', value: '厨房前'},
        ]
      },
      {
        timeList: [
          { label: '5秒', value: '5秒'},
        ],
        storeList: [
          { label: '中野店', value: '中野店'},
        ],
        cameraSettingList: [
          { label: '厨房前', value: '厨房前'},
        ]
      },
    ],
  }),
  watch: {
    dialogVisible: function(item) {
      this.cameraTourDialogVisible = item;
    },
    cameraTourDialogVisible: function(item) {
      this.$emit('visible', item);
    }
  },
  created() {
  },
  methods: {
    deleteTourItem(index) {
      this.tourList.splice(index, 1);
    },
  }
}
</script>

<style lang="scss" scoped>
#tour_dialog_text{
  color: white;
  text-align: left;
}
#dialog_row {
  border-bottom: 1px solid #4A4A4A;
}
#transparent_btn_small {
  background-color: transparent;
  max-width: 3em;
  min-width: 3em;
  padding-right: 2em;
}
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item{
    min-height: 0px;
    color: white !important;
  }
  .v-list-item__content{
    color: white;
    padding: 5px 0;
  }
  .v-input__slot {
		padding-right: 2px !important;
	}
	.v-input__append-inner {
		margin-top: 16px !important;
		padding-left: 0px !important;
	}
  // Select Box Height 설정
	.v-text-field--outlined > .v-input__control > .v-input__slot {
		min-height: 35px !important;
	}
	.v-text-field--outlined.v-input--dense.v-text-field--outlined > .v-input__control {
		height: 35px;
	}
}
</style>